import { useContext } from 'react';
import { SearchQueryStoreContext } from './GenerateSearchQueryProvider';
export const useSearchQuery = () => {
  const store = useContext(SearchQueryStoreContext);
  if (!store || !store.query) {
    throw new Error('useSearchQuery must be inside GenerateSearchQueryProvider');
  }
  return store.query;
};